import { Card, CardContent, Stack, Typography } from '@mui/material/';
import { FunctionComponent } from 'react';
import { CardListRow } from '@/components/Card/CardListRow';
import { Box, List } from '@mui/material';
import { LogoUploadContainer } from './LogoUploadContainer';

export const MailGraphics: FunctionComponent = () => {
    return (
        <Stack spacing={3}>
            <Box>
                <Typography gutterBottom>
                    Erstellen Sie Ihre Header- / Footer-Grafik für Ihre E-Mails
                    und laden Sie diese hier hoch. Beachten Sie unbedingt
                    folgende Spezifikationen:
                </Typography>
                <List
                    sx={{
                        pl: 6,
                        listStyleType: 'disc',
                    }}
                    component='ul'
                >
                    <li>Dateityp: .jpg / .png / .gif</li>
                    <li>Maximale Größe: 512kb</li>
                    <li>Format: 580 px Breite – Höhe variabel</li>
                    <li>Auslösung: 72dpi</li>
                </List>
            </Box>

            <Card>
                <CardContent
                    sx={{
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant='h6'>
                        Mail Header / Footer anpassen
                    </Typography>
                </CardContent>

                <CardListRow
                    sx={{
                        backgroundColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography sx={{ width: '50%', fontWeight: 600 }}>
                        Mail Header
                    </Typography>

                    <Typography sx={{ width: '50%', fontWeight: 600 }}>
                        Mail Footer
                    </Typography>
                </CardListRow>

                <CardContent>
                    <Box sx={{ display: 'flex', width: '100%' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexGrow: 1,
                            }}
                        >
                            <LogoUploadContainer logoType='header' />
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexGrow: 1,
                            }}
                        >
                            <LogoUploadContainer logoType='footer' />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Stack>
    );
};
